// Toasts (spec §11): top centre under the bar, one at a time, gone after 4 s. `toast()` is called from
// anywhere (the palette's Copy link, the gallery); the component shows the latest.

import { useEffect, useState } from 'react';
import './web.css';

export const TOAST_MS = 4000;

type Listener = (text: string | null) => void;
const listeners = new Set<Listener>();
let current: string | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;

/** Show one line for a few seconds; a new one replaces it. */
export function toast(text: string) {
  current = text;
  clearTimeout(timer);
  timer = setTimeout(() => {
    current = null;
    for (const fn of listeners) fn(null);
  }, TOAST_MS);
  for (const fn of listeners) fn(text);
}

/** Copy `text` to the clipboard and say so; says when the browser refuses (no secure context, no permission). */
export async function copyToClipboard(text: string, what = 'Link'): Promise<boolean> {
  try {
    if (!navigator.clipboard) throw new Error('no clipboard');
    await navigator.clipboard.writeText(text);
    toast(`${what} copied`);
    return true;
  } catch {
    toast(`Couldn’t copy the ${what.toLowerCase()}`);
    return false;
  }
}

export function Toasts() {
  const [text, setText] = useState<string | null>(current);
  useEffect(() => {
    listeners.add(setText);
    return () => {
      listeners.delete(setText);
    };
  }, []);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {text ? <div className="toast ba-type-small">{text}</div> : null}
    </div>
  );
}
